import {
  AppealsSubjects,
  CreateAppealFormDataRequest,
} from 'shared/api/AppealModel.ts'
import { Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

export const AppealApi = {
  getAppealsTopics(billingNumber: string) {
    return clientApi.get<Response<AppealsSubjects[]>>(
      `/crm/web/appeals-subjects/${billingNumber}`,
    )
  },
  onCreateAppeal(data: CreateAppealFormDataRequest) {
    return clientApi.post('/crm/web-appeals', data)
  },
  onCreateAppealSimple(
    data: Omit<CreateAppealFormDataRequest, 'billing_number' | 'topic'>,
  ) {
    return clientApi.post('/crm/web-appeals/simple', data)
  },
}
